import { ApplicationState, Source } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { createOptionsSelector } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'sources';

export const SOURCES_UPDATED = prefix('SOURCES_UPDATED');

export const setSources = (sources: Array<Source>) => createAction(SOURCES_UPDATED, sources);

export const sourcesReducer = createEntitiesReducer({
    UPDATE_SUCCESS: SOURCES_UPDATED,
});

export const [getSources, getSourcesByIds, getSourcesByOwnerId, getSource] = createBaseEntitySelectors<
    ApplicationState,
    Source,
    typeof NAME
>(parentSelector, NAME);

export const getSourceOptions = createOptionsSelector(getSources, { value: 'id', label: 'name' });
